import { render, staticRenderFns } from "./DetailPembelianPo.vue?vue&type=template&id=b3545846&"
import script from "./DetailPembelianPo.vue?vue&type=script&lang=js&"
export * from "./DetailPembelianPo.vue?vue&type=script&lang=js&"
import style0 from "./DetailPembelianPo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports